module.exports = __webpack_public_path__ + "assets/fe0a613a43f0a6dd5cb7b4eab4676a41.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/pickbonus/Background.mp3
 ** module id = 218
 ** module chunks = 0
 **/